import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link,useHistory } from 'react-router-dom'

const Service = ({ title, shortDescription, icon, id, imageTag
  // iconStyle, imgStyle
 }) => {
  const history=useHistory();
  const currentUrl = window.location.href;
  console.log('current url',currentUrl)

  useEffect(()=>{
    if (currentUrl.includes("/services")) {
      // Apply styles for URL containing "example.com/page1"
      const elements = document.querySelectorAll(".service-home-mobile");
      elements.forEach((element) => {

        element.style.position = "relative";
        element.style.left = "50%";
        element.style.setProperty("transform", "translateX(-50%)", "important");
        element.style.marginLeft = "0";
      });
        // Add any other CSS styles as needed

    }
  })
  // console.log(icon)
  // console.log(iconStyle, imgStyle)
  return (
    // <div className="services-list wow fadeInUp">
    //   <Link to={`/services/${id}`}>
    //     {/* <div className="services-icon" style={iconStyle}> */}
    //     <div className="services-icon">
    //       {/* <img src={icon} alt="" style={imgStyle} /> */}
    //       <img src={icon} alt={imageTag} className="small-icon" />
    //     </div>
    //     <div className="services-contetnt">
    //       <h5>{title}</h5>
    //     </div>
    //     <div className="services-overlay">
    //       <p>{shortDescription}...</p>
    //     </div>
    //   </Link>
    // </div>
    <>
    <Link to={`/services/${id}`}>
    <div className="service-home wow fadeInUp">
      <img src={icon} alt={imageTag} className="service-image" />
      <h5 className="service-title">{title}</h5>
      <p className="service-description">{shortDescription}...</p>

    </div>
    </Link>
    <Link to={`/services/${id}`}>
    <div className="service-home-mobile wow fadeInUp mb-3">
      <img src={icon} alt={imageTag} className="service-image-mobile" />
      <h5 className="service-title-mobile">{title}</h5>
      <p>{shortDescription}...</p>

    </div>
    </Link>
    </>
  )
}

Service.propTypes = {
  id: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  shortDescription: PropTypes.string.isRequired,
  // iconStyle: PropTypes.object,
  // imgStyle: PropTypes.object,
}

Service.defaultProps = {
  // iconStyle: { '': '' },
  // imgStyle: { '': '' },
}

// Service.defaultProps = {
//   icon: '/resources/img/sabinehospital-icons/sabinehospital-services-icon-01.svg',
//   title: 'Service',
//   shortDescription: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit',
// }

export default Service
